var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"avatarIdle"},[_c('table',[_c('tr',[_c('td',[_c('img',{attrs:{"src":'./static/Idle.png'}})])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"idleMessage"},[(_vm.idleMessage)?_c('span',[_vm._v(_vm._s(_vm.idleMessage))]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cac90c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Idle.vue
// module id = null
// module chunks = 